export const ItemTypes = {
    PlaylistItem : 'playlistItem',
    ContentItem: 'contentItem',
    TagItem: 'tagItem',
};